var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAirportIconFarmstrip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 144.083 180",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M72.405 14.702v-.02c-.123 0-.242.008-.363.008s-.241-.008-.364-.008v.02c-24.63.391-44.477 20.465-44.477 45.186 0 33.314 39.114 64.938 44.841 69.43 5.727-4.492 44.84-36.115 44.84-69.43-.001-24.721-19.846-44.795-44.477-45.186Zm35.624 40.85L87.26 62.383l4.96 14.185-9.548 4.545-6.279-15.976-33.788 11.133-2.746-8.92L72.953 56.01 61.877 26.562l10.9-3.113 10.787 29.267 20.433-6.917Z",
    style: {
      fill: "green"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      strokeWidth: 0.13482969
    },
    d: "M82.67 80.937c-.029-.055-1.438-3.635-3.132-7.955-1.694-4.32-3.134-7.854-3.2-7.854-.068 0-7.595 2.466-16.73 5.48-9.134 3.013-16.692 5.485-16.795 5.494-.213.017-2.912-8.539-2.743-8.698.055-.052 7.467-2.619 16.473-5.705 9.005-3.086 16.396-5.633 16.423-5.66.027-.028-2.357-6.442-5.298-14.255a8851.882 8851.882 0 0 1-5.524-14.695l-.177-.49 5.32-1.52c3.162-.903 5.37-1.47 5.44-1.398.066.067 2.498 6.584 5.403 14.481 2.906 7.898 5.334 14.414 5.394 14.48.063.067 1.583-.379 3.524-1.035l10.164-3.441 6.752-2.287 1.979 4.793c1.088 2.636 1.96 4.812 1.936 4.835-.024.024-4.68 1.568-10.349 3.431a2506.562 2506.562 0 0 0-10.325 3.407c-.01.01 1.094 3.202 2.455 7.093 1.36 3.89 2.46 7.086 2.445 7.102-.015.015-2.03.979-4.477 2.142a614.086 614.086 0 0 0-4.676 2.235c-.125.067-.252.076-.281.02z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirportIconFarmstrip);
export default __webpack_public_path__ + "static/media/airport_icon_farmstrip.4212bed55e03332e3516275a2138c3e1.svg";
export { ForwardRef as ReactComponent };